module.exports = __webpack_public_path__ + "media/img/frontend_application/christmas/partner-one-8a4904803db0fd6449e109c5dddb1026.png";